import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Layout from "../components/Layout";
import styled from "styled-components";
import Drawer from "../components/Drawer";
import { useState } from "react";
import Miniheader from "../components/Miniheader";
import TextField from "../components/TextField";
import FileField from "../components/FileField";
import { COLORS } from "../contants/colors";
import GreenButton from "../components/GreenBtn";
import WhiteBtn from "../components/WhiteBtn";
import Dropdown from "../components/Dropdown";
import { QUERIES } from "../contants/allConstants";
import PhoneInput from "react-phone-input-2";
import fr from "react-phone-input-2/lang/fr.json";
import it from "react-phone-input-2/lang/it.json";
import "react-phone-input-2/lib/style.css";
import ToastContainer from "react-bootstrap/esm/ToastContainer";
import Collapse from "react-bootstrap/Collapse";
import Toast from "react-bootstrap/Toast";
import countries from "../contants/countries.json";
import subdivisions from "../contants/subdivisions.json";
import states from "../contants/statesByCountry.json";

import { useLanguageContext } from "../languageContext";
import TextArea from "./TextArea";

const ShareVideo = ({video, onShareNews, onClose  }) => {
  const { userInfo } = useSelector((state) => state.userLogin);
  const { supervisor, error, loading } = useSelector(
    (state) => state.supervisor
  );
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [localization, setLocalization] = useState(fr);
  const [lang, setLang] = useState("fr");

  const { t } = useLanguageContext();

  const onCreate= () => {
    if (
      title !== "" &&
      description !== "" 
    ) {
      
      onShareNews(
          video._id,
          title,
          description,
          () => {
            onClose()
            setMessage(t("successShareVideo"));
            setToastType("success");
            setTitle("");
            setDescription("");
          }
        )
      
    } else {
      setMessage(t("fillout"));
      setToastType("danger");
    }
  };

  const onCancel = () => {
    setTitle("");
    setDescription("");
    onClose();
  };
  useEffect(() => {
    if (error) {
      setMessage(error !== "" ? t(error) : t("mainError"));
      setToastType("danger");
    }
  }, [error]);

  useEffect(() => {
    setTimeout(() => {
      setToastType("");
    }, 8000);
  }, [toastType]);

  useEffect(() => {
    const lang = JSON.parse(localStorage.getItem("langAnisso")).lang;
    if (lang === "fr") {
      setLocalization(fr);
      setLang("fr");
    } else if (lang === "en") {
      setLocalization("en");
      setLang("us");
    } else {
      setLocalization(it);
      setLang("it");
    }
  }, []);
  return (
    <Container>
      <Shadow>
      <Body>
          <Head>
            <Icon
              onClick={() => onClose()}
              src={require("../images/whiteClose.svg").default}
              alt=""
            />
            <HTitle>{t("shareNews")}</HTitle>
          </Head>
        <Wrapper>
          <Row>
            <Col>
              <TextField
                title={t("title")}
                hint={""}
                value={title}
                onChange={(value) => setTitle(value)}
              />
              <TextArea
                title={t("description")}
                hint={""}
                value={description}
                onChange={(value) => setDescription(value)}
              />
             </Col>
            <Divider />
            <Col>
              <VideoPreview controls key={video.link}>
                <source src={video.link} type="video/mp4" key={video.link} />
              </VideoPreview>
              <Row>
                <GreenButton
                  title={t("send")}
                  onClick={() => onCreate()}
                  loading={loading}
                />
                <WhiteBtn title={t("cancel")} onClick={() => onCancel()} />
              </Row>
            </Col>
          </Row>
        </Wrapper>
        {toastType !== "" && (
          <ToastContainer
            containerPosition="sticky"
            position="top-end"
            style={{
              position: "fixed !important",
              bottom: "40%",
              right: 0,
              zIndex: "2000",
              float: "right",
              textAlign: "left",
            }}
          >
            <Toast
              delay={7000}
              animation
              transition={Collapse}
              bg={toastType}
              style={{
                borderRadius: "4px",
                fontFamily: "Din",
                padding: "0 30px",
              }}
            >
              <Toast.Body className={"text-white"}>{message}</Toast.Body>
            </Toast>
          </ToastContainer>
        )}
      </Body>

      </Shadow>
    </Container>
  
  );
};

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
`;
const Shadow = styled.div`
  background-color: ${COLORS.shadow};
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  height: 100vh;
  overflow-y: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // text-align: left;
  @media (${QUERIES.tabletAndDown}) {
    // height: max-content;
    height: 100%;
  }
`;
const Body = styled.div`
  padding: 3vw 4vw;
  position: relative;
`;
const Wrapper = styled.div`
  background-color: white;
  padding: 20px 40px;
  border-bottom-left-radius:10px ;
  border-bottom-right-radius:10px ;
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  @media (${QUERIES.mobileAndDown}) {
    flex-direction: column;
  }
`;
const Col = styled.div`
  flex: 1;
  min-width:250px
`;
const Divider = styled.div`
  width: 1px;
  background-color: ${COLORS.gray700};
  margin: 0 20px;
`;
const Icon = styled.img`
  width: 10px;
  height: 10px;
  object-fit: fill;
  cursor: pointer;
  float: right;
  margin: 12px 16px 0 0;
`;
const Head = styled.div`
  width: 100%;
  height: 36px;
  background-color: ${COLORS.primary};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
const HTitle = styled.p`
  color: white;
  font-family: "Din";
  font-size: 0.9rem;
  font-weight: 700;
  text-align: center;
  margin: 0;
  padding-top: 6px;
`;
const VideoPreview = styled.video`
  height: 170px;
  width: 100%;
  min-width:250px;
  object-fit: cover;
  border-radius: 9px;
`;
export default ShareVideo;
